import React from "react";


const NotUsSection = () => {
  const items = [
    {
      no: "No somos una gestoría",
      pero: "tenemos relación directa con ella"
    },
    {
      no: "No llevamos la contabilidad diaria",
      pero: "ayudamos a tener todo limpio desde el inicio"
    },
    {
      no: "No vendemos informes sin conversación",
      pero: "tendrás el reporting para tus inversores"
    }
  ];

  return (
    <section className="home2-notus">
      <div className="home2-section-content">
        <h2 className="home2-section-title">
          Qué no hacemos (y por qué).
        </h2>

        <div className="home2-notus-items">
          {items.map((item, index) => (
            <div key={index} className="home2-notus-item">
              <div className="home2-notus-no">
                <span className="home2-notus-x">✕</span>
                {item.no}...
              </div>
              <div className="home2-notus-pero-divider">
                <span className="home2-notus-pero-label">PERO</span>
              </div>
              <div className="home2-notus-pero">
                {item.pero}
              </div>
            </div>
          ))}
        </div>

        <p className="home2-notus-closing">
          Nuestro valor no está en hacer más cosas.
          <br />
          Está en hacer las correctas.
        </p>
      </div>
    </section>
  );
};

export default NotUsSection;
